import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';

class CreateInsuranceLead extends baseRequest
{
    constructor(updateState, handleFailure) {
        super();
        this.name = 'CreateInsuranceLead';
        this.dispatch = null;
        this.response = null;
        this.config = new AppConfig();
        this.updateState = updateState;
        this.handleFailure = handleFailure;
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.config.api.requests.createInsuranceLead, payload);
    }

    onSuccess() {
        this.updateState(this.response.data);
    }

    onFailure(response, methodName = '') {
        super.onFailure(response, methodName);
        this.handleFailure();
    }

    handleServerError(error) {
        super.handleServerError(error);
        this.handleFailure();
    }
}

export default CreateInsuranceLead;
